import { utcToZonedTime } from 'date-fns-tz'

import { Cart, Location, Shop } from 'Types'

export const sendKlaviyoPurchaseEvent = (cart: Cart, location: Location, shop: Shop): void => {
  // @ts-ignore: ignore klaviyo declaration
  window.klaviyo = window.klaviyo || []

  // Fulfillment date
  const fulfillmentDate = utcToZonedTime(new Date(cart.fulfillment?.currentFulfillmentAt as string), location.timezone)

  const items = cart.cartItems.map((item) => {
    return {
      id: `P${item.id}`,
      name: item.name,
      image_url: item.coverSerializableHash.url,
      list_name: item.categoryName,
      brand: item.name,
      category: item.type || '',
      variant: item.variantName || '',
      list_position: item.menuId,
      quantity: item.quantity,
      price: `${item.totalPrice}`,
    }
  })

  // @ts-ignore: ignore klaviyo declaration
  window.klaviyo.push([
    'track',
    'Purchase',
    {
      transaction_id: `T_${cart.id}`,
      affiliation: 'Online Ordering',
      value: cart.totalMoney,
      currency: shop.currency || 'CAD',
      tax: cart.totalTaxAndFeesMoney,
      shipping: cart.totalDeliveryCostMoney,
      location: location?.name || '',
      fulfillment_type: cart.fulfillment?.kind || '',
      fulfillment_date: fulfillmentDate,
      items,
    },
  ])
}
